module.exports = __webpack_public_path__ + "static/media/222-Sturz-Ansprechen-Teil2-Milo_ID_8.57de2350.mp3";